/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PlatformLocation } from '@angular/common';
declare var $: any;

@Component({
  selector: 'zsd-datefield',
  templateUrl: '../../view/customfields/datefield.component.html',
  styleUrls: ['../../view/customfields/customfields.component.scss']
})
export class DateFieldComponent implements OnInit {

  @Input() displayName = '';
  @Input() valueType;
  @Input() description;
  @Input() dscEnable;
  @Input() required;
  @Input() fieldId;
  @Input() clientEditable;
  @Input() defaultValue;
  @Input() dateFormat;

  @Input('parentForm') public parentForm: FormGroup;
  @Input('fromQuickCall') public fromQuickCall: boolean;
  @Input('id') public id: number;


  customFieldDateForm: FormGroup;
  dataValue;

  readonly VALUE_TYPE_DATE = 0;
  readonly VALUE_TYPE_DATETIME = 1;

  constructor(public formBuilder: FormBuilder, location: PlatformLocation) {
    location.onPopState(() => {
        $('#ui-datepicker-div').hide();
     });
  }

  ngOnInit() {
    // Setup for Reactive Form

    this.customFieldDateForm = this.formBuilder.group({
      data: this.formBuilder.control({ value: '', disabled: (this.clientEditable ? false : true) }),
    });


    if (this.defaultValue) {
      this.customFieldDateForm.get('data').setValue(this.defaultValue);
    }
    if (this.required === 1) {
      this.customFieldDateForm.get('data').setValidators([Validators.required]);
    }
    this.customFieldDateForm.updateValueAndValidity();
    if (this.parentForm) {
      this.parentForm.addControl(this.fieldId + '', this.customFieldDateForm);
    }
    this.parentForm.setControl(this.fieldId + '', this.customFieldDateForm);

    // Setup for date picker jquery

    if (this.valueType === this.VALUE_TYPE_DATE) {
      if (this.id === null) {
        $(function () {
          $('#' + this.fieldId).datepicker({
            dateFormat: this.dateFormat,
            onSelect: function (selectedDateTime) {
              this.customFieldDateForm.get('data').setValue(selectedDateTime);
              this.customFieldDateForm.updateValueAndValidity();
            }.bind(this)
          });
        }.bind(this));
      } else {
        $(function () {
          $('#' + this.id + 'qc' + this.fieldId).datepicker({
            dateFormat: this.dateFormat,
            onSelect: function (selectedDateTime) {
              this.customFieldDateForm.get('data').setValue(selectedDateTime);
              this.customFieldDateForm.updateValueAndValidity();
            }.bind(this)
          });
        }.bind(this));
      }
    } else if (this.valueType === this.VALUE_TYPE_DATETIME) {
      if (this.id === null) {
        $(function () {
          $('#' + this.fieldId).datetimepicker({
            dateFormat: this.dateFormat,
            timeFormat: 'HH:mm',
            onSelect: function (selectedDateTime) {
              this.customFieldDateForm.get('data').setValue(selectedDateTime);
              this.customFieldDateForm.updateValueAndValidity();
            }.bind(this)
          });
        }.bind(this));
      } else {
        $(function () {
          $('#' + this.id + 'qc' + this.fieldId).datetimepicker({
            dateFormat: this.dateFormat,
            timeFormat: 'HH:mm',
            onSelect: function (selectedDateTime) {
              this.customFieldDateForm.get('data').setValue(selectedDateTime);
              this.customFieldDateForm.updateValueAndValidity();
            }.bind(this)
          });
        }.bind(this));
      }
    }

    // Setup for description jquery

    if (this.dscEnable === 1) {
      $(document).ready(function () {
        $('[data-toggle=' + this.fieldId + ']').popover();
      }.bind(this));
    }


  }

}
